<template>
  <el-scrollbar
    class="column-bar-container"
    :class="{
      'is-collapse': collapse,
      ['column-bar-container-' + theme.columnStyle]: true,
    }"
  >
    <vab-logo />
    <el-tabs
      v-model="extra.first"
      tab-position="left"
      @tab-click="handleTabClick"
    >
      <el-tab-pane
        v-for="item in handleRoutes"
        :key="item.name"
        :name="item.name"
      >
        <template #label>
          <div
            class="column-grid"
            :class="{
              ['column-grid-' + theme.columnStyle]: true,
            }"
            :title="translateTitle(item.meta.title)"
          >
            <div>
              <vab-icon
                v-if="item.meta.icon"
                :icon="item.meta.icon"
                :is-custom-svg="item.meta.isCustomSvg"
              />
              <span>
                {{ translateTitle(item.meta.title) }}
              </span>
            </div>
            <!-- 关闭按钮 -->
            <!-- <vab-icon
                v-if="isShowCloseBtn(item.path)"
                icon="close-circle-fill"
                class="route-close-btn"
                @click.stop="closeRoute(item.path)"
              /> -->
          </div>
        </template>
      </el-tab-pane>
    </el-tabs>

    <el-menu
      :background-color="variables['column-second-menu-background']"
      :default-active="activeMenu"
      :default-openeds="defaultOpeneds"
      mode="vertical"
      :unique-opened="uniqueOpened"
    >
      <el-divider>
        {{ translateTitle(handleGroupTitle) }}
      </el-divider>
      <template v-for="route in handlePartialRoutes">
        <vab-menu v-if="!route.hidden" :key="route.fullPath" :item="route" />
      </template>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { ref, computed, watchEffect } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { translateTitle } from '@/utils/i18n'
import { handleActivePath } from '@/utils/routes'
import { defaultOpeneds, openFirstMenu, uniqueOpened } from '@/config'
import variables from '@/vab/styles/variables/variables.scss'
import storejs from 'store'
export default {
  name: 'ColumnBar',
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const dyRoutes = computed(
      () => {
        const list = store.getters['routes/dynamicRoutes'].length?store.getters['routes/dynamicRoutes'] : storejs.get('dynamicRoutes') || []
        // console.log('list =======', list)
        return list
      }
    )
    const routes = computed(() => store.getters['routes/routes'])
    
    const extra = computed(() => store.getters['settings/extra'])
    const theme = computed(() => store.getters['settings/theme'])
    const collapse = computed(() => store.getters['settings/collapse'])

    const activeMenu = ref('')

    const handleRoutes = computed(() => {
      const dy = ref([...dyRoutes.value])
      const ro = ref([...routes.value])
      var newRo = []
      const dyPathList = dy.value.map((item) => item.path)
      if (dy.value.length) {
        for (let index = 0; index < ro.value.length; index++) {
          if (dyPathList.indexOf(ro.value[index].path) === -1) {
            newRo.push(ro.value[index])
          }
        }
      } else {
        newRo = [...ro.value]
      }
      const allRoutes = ref([...dy.value,...newRo])
      return allRoutes.value.filter((item) => item.hidden !== true && item.meta)
    })
    const handlePartialRoutes = computed(() => {
      const activeMenu = routes.value.find((_) => _.name === extra.value.first)
      return activeMenu ? activeMenu.children : []
    })
    const handleGroupTitle = computed(() => {
      const activeMenu = routes.value.find((_) => _.name === extra.value.first)
      return activeMenu ? activeMenu.meta.title : ''
    })
    // 计算是否显示关闭图标
    const isShowCloseBtn = (path)=>{
      const dy = ref([...dyRoutes.value])
      const dyPathList = dy.value.map((item) => item.path)
      return dyPathList.indexOf(path)>-1
    }
    //关闭路由
    const closeRoute = (path)=>{
      const dy = ref([...dyRoutes.value])
      const dyPathList = dy.value.map((item) => item.path)
      const index = dyPathList.indexOf(path)
      const currentPath = route.matched[0].path
      if(index>-1){
          dy.value.splice(index,1)
          if(path===currentPath){//关闭自身
            if(dy.value.length!=0){
              router.push(dy.value[0])
            }else {
              router.push('/widget')
            }
          }
          store.dispatch('routes/setDynamicRoutes', [...dy.value])
          storejs.set('dynamicRoutes',[...dy.value])
      }
    }
    const handleTabClick = (handler) => {
      if (handler !== true && openFirstMenu) {
        router.push(handlePartialRoutes.value[0])
        store.dispatch('settings/openSideBar')
      }
    }

    watchEffect(() => {
      activeMenu.value = handleActivePath(route)
      const firstMenu = route.matched[0].name
      if (extra.value.first !== firstMenu) {
        extra.value.first = firstMenu
        handleTabClick(true)
      }
    })

    return {
      extra,
      theme,
      collapse,
      variables,
      activeMenu,
      handleRoutes,
      uniqueOpened,
      defaultOpeneds,
      handleTabClick,
      translateTitle,
      handleGroupTitle,
      handlePartialRoutes,
      isShowCloseBtn,
      closeRoute
    }
  },
}
</script>

<style lang="scss" scoped>
.route-close-btn {
  position: absolute;
  top: -8px;
  right: 3px;
  color: #ddd;
}
@mixin active {
  &:hover {
    color: $base-color-blue;
    background-color: $base-column-second-menu-background-active !important;

    i,
    svg {
      color: $base-color-blue;
    }
  }

  &.is-active {
    color: $base-color-blue;
    background-color: $base-column-second-menu-background-active !important;
  }
}

.column-bar-container {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: $base-left-menu-width;
  height: 100vh;
  overflow: hidden;
  background: $base-column-second-menu-background;
  box-shadow: $base-box-shadow;

  :deep() {
    * {
      transition: $base-transition;
    }
  }

  &-vertical,
  &-card {
    :deep() {
      .el-tabs + .el-menu {
        left: $base-left-menu-width-min;
        width: $base-left-menu-width - $base-left-menu-width-min;
        border: 0;
      }
    }
  }

  &-horizontal {
    :deep() {
      .logo-container-column {
        .logo {
          width: $base-left-menu-width-min * 1.3 !important;
        }

        .title {
          margin-left: $base-left-menu-width-min * 1.3 !important;
        }
      }

      .el-tabs + .el-menu {
        left: $base-left-menu-width-min * 1.3;
        width: $base-left-menu-width - $base-left-menu-width-min * 1.3;
        border: 0;
      }
    }
  }

  &-card {
    :deep() {
      .el-tabs {
        .el-tabs__item {
          padding: 5px !important;

          .column-grid {
            width: $base-left-menu-width-min - 10 !important;
            height: $base-left-menu-width-min - 10 !important;
            border-radius: 5px;
          }

          &.is-active {
            background: transparent !important;

            .column-grid {
              background: $base-color-blue;
            }
          }
        }
      }

      .el-tabs + .el-menu {
        left: $base-left-menu-width-min + 10;
        width: $base-left-menu-width - $base-left-menu-width-min - 20;
      }

      .el-submenu .el-submenu__title,
      .el-menu-item {
        min-width: 180px;
        border-radius: 5px;
      }
    }
  }

  .column-grid {
    display: flex;
    align-items: center;
    width: $base-left-menu-width-min;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    white-space: nowrap;

    &-vertical,
    &-card {
      justify-content: center;
      height: $base-left-menu-width-min;

      > div {
        svg {
          position: relative;
          top: 8px;
          display: block;
          width: $base-font-size-default + 4;
          height: $base-font-size-default + 4;
        }

        [class*='ri-'] {
          display: block;
          height: 20px;
        }
      }
    }

    &-horizontal {
      justify-content: left;
      width: $base-left-menu-width-min * 1.3;
      height: $base-left-menu-width-min / 1.3;
      padding-left: $base-padding / 2;
    }
  }

  :deep() {
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    .el-tabs {
      position: fixed;

      .el-tabs__header.is-left {
        .el-tabs__nav-wrap.is-left {
          margin-right: 0 !important;
          background: $base-column-first-menu-background;

          .el-tabs__nav-scroll {
            height: 100%;
            overflow-y: auto;

            &::-webkit-scrollbar {
              width: 0px;
              height: 0px;
            }
          }
        }
      }

      .el-tabs__nav {
        height: calc(100vh - #{$base-logo-height});
        background: $base-column-first-menu-background;
      }

      .el-tabs__item {
        height: auto;
        padding: 0;
        color: $base-color-white;

        &.is-active {
          background: $base-color-blue;
        }
      }
    }

    .el-tabs__active-bar.is-left,
    .el-tabs--left .el-tabs__nav-wrap.is-left::after {
      display: none;
    }

    .el-menu {
      border: 0;

      .el-divider {
        margin: 0 0 $base-margin 0;
        background-color: #f6f6f6;

        &__text {
          color: $base-color-black;
        }
      }

      .el-menu-item,
      .el-submenu__title {
        height: $base-menu-item-height;
        overflow: hidden;
        line-height: $base-menu-item-height;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;

        @include active;
      }
    }
  }

  &.is-collapse {
    :deep() {
      width: 0;
    }
  }
}
</style>
